import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonLoading,
  IonModal,
  IonTitle,
  IonToolbar
} from '@ionic/react'
import React, { useState } from 'react'
import { PrismicClient, PrismicDocument } from '../prismic'
import { PrismicBody } from './prismic/body'

interface Props {
  onConfirmRead?: () => any
}

export const PrivacyModal: React.FC<Props> = (props) => {
  const [privacyModal, setPrivacyModal] = useState(false)
  const [showLoading, setShowLoading] = useState(false);
  const [doc, setDocData] = React.useState<PrismicDocument>()

  const fetchData = async () => {
    if (!doc) {
      setShowLoading(true)
      setDocData(await PrismicClient.getByUID('web-page', 'privacy', {}))
      setShowLoading(false)
    }

    setPrivacyModal(true)
  }

  const confirm = () => {
    setPrivacyModal(false)

    props.onConfirmRead && props.onConfirmRead()
  }

  return (
    <>
      <IonButton
        fill={'clear'}
        color="primary"
        expand={'block'}
        onClick={() => fetchData()}
      >Details Anzeigen</IonButton>

      <IonModal
        isOpen={privacyModal}
        onDidDismiss={() => setPrivacyModal(false)}>
        <IonHeader translucent>
          <IonToolbar color={'primary'}>
            <IonTitle>{doc?.data.title || ''}</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setPrivacyModal(false)}>Schließen</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          <IonLoading
            isOpen={showLoading}
            onDidDismiss={() => setShowLoading(false)}
            message={'Seite wird geladen...'}
          />
          {doc && <PrismicBody data={doc?.data.body} />}
        </IonContent>

        {props.onConfirmRead && <IonButton onClick={confirm}>Gelesen und Akzeptiert</IonButton>}
      </IonModal>
    </>
  )
}
